import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteDistrict } from '../../../../actions';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

class DeleteDistrictButton extends Component {
  state = {
    showWarningModal: false,
  };

  showDeleteModal = () => this.setState({ showWarningModal: true });

  closeDeleteModal = () => this.setState({ showWarningModal: false });

  handleDelete = () => {
    const { districtId, dispatchDeleteDistrict } = this.props;
    dispatchDeleteDistrict({ districtId });
  };

  render() {
    const { showWarningModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={this.handleDelete}
        onClickCancel={this.closeDeleteModal}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.showDeleteModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

DeleteDistrictButton.propTypes = {
  districtId: PropTypes.number.isRequired,
  dispatchDeleteDistrict: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteDistrict: deleteDistrict,
};

export default connect(null, mapDispatchToProps)(DeleteDistrictButton);
